import Swal from 'sweetalert2';

export const stopRemovebgLoader = ({ isBlurBg = false }) => {
  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: `Lo sfondo &egrave; stato ${
      isBlurBg ? 'sfocato' : 'rimosso'
    }. Troverai la nuova immagine tra gli allegati di questo servizio`,
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};
